<template>
  <div>
    <!-- 头部 -->
    <div class="new_top">
      <header2></header2>
      <navigation ref="navigation"></navigation>
    </div>
    <!--中间主体-->
    <div class="sy_main">
      <div class="sym_top">
        <!--轮播图-->
        <div >
          <div class="symt_pic" id="main_flexslider">
            <el-carousel trigger="click" height="279px" style="width:331px;" indicator-position="none">
              <el-carousel-item v-for="item in topCarousel" :key="item.id">
                <a target="_blank" :href="item.url"><img :src="item.imgUrl" width="331" height="249"/></a>
                <p class="flex-caption"><a target="_blank" :href="item.url">{{item.title}}</a></p>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <!--<div class="symt_pic"><img src="../assets/img/lunbo.jpg" width="331" height="279"></div>-->
        <!--热点新闻-->
        <div class="symt_news">
          <div class="symt_news_ncov"><router-link :to="{ path: '/nCoV2019Knowledge'}" ><img src="../assets/img/kepu.jpg"></router-link></div>
          <div class="symt_news_title">热点新闻<router-link :to="{ path: '/hotNews'}" >[更多...]</router-link></div>
          <div class="symt_news_main">
            <ul>
              <li v-for="item in rdxwList" :key="item.id"  >
                <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
              </li>
            </ul>
          </div>
        </div>
        <!--登录-->
        <login></login>
      </div>

      <div class="sym_content">
        <!--左侧三竖模块-->
        <div class="symc_left">
          <div class="symcl_box">
            <div class="symcl_box_title">党风党建</div>
            <div class="symcl_box_main">
              <div class="symcl_box_main_cell">
                <!--<router-link  :to="{ path: '/dangfengdangjian'}" ><img src="../assets/img/123.gif" /></router-link>-->
                <el-carousel trigger="click" height="237px" width="199px" indicator-position="none">
                  <el-carousel-item v-for="item in leftCarousel" :key="item.id">
                    <a target="_blank" :href="item.url"><img :src="item.imgUrl" width="199" height="237"/></a>
                    <!--<p class="flex-caption"><a target="_blank" :href="item.url">{{item.title}}</a></p>-->
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
          <div class="symcl_box">
            <div class="symcl_box_title" style="padding-left: 28px;"><img src="../assets/img/down_coures_pic.png" width="20" height="20" />下载专区</div>
            <div class="symcl_box_main">
              <div class="symcl_box_main_cell" style="height:324px;overflow: hidden;">
                <router-link  :to="{ path: '/downLoad'}" class="table_down"><img src="../assets/img/down_execl.jpg" width="161" height="31"/></router-link>
                <ul class="xiazai">
                  <!--<li><a href="" title="湖北省继续医学教育Ⅰ类学分审验表（2017年度）">湖北省继续医学教育Ⅰ类学分审验表（2017年度）</a></li>
                  <li><a href="" title="十堰卫生数字化学习成交费名单">十堰卫生数字化学习成交费名单</a></li>
                  <li><a href="" title="十堰市2017年度继续医学教育项目申报表">十堰市2017年度继续医学教育项目申报表</a></li>
                  <li><a href="" title="2016年《湖北省继续医学教育Ⅰ类学分审验表》《湖北省继续医学教育Ⅰ类学分审验汇总表》《十堰市继续医学教育Ⅱ类学分审验表》">2016年《湖北省继续医学教育Ⅰ类学分审验表》《湖北省继续医学教育Ⅰ类学分审验汇总表》《十堰市继续医学教育Ⅱ类学分审验表》</a></li>
                  <li><a href="" title="十堰市市级继续医学教育项目申报表">十堰市市级继续医学教育项目申报表</a></li>
                  <li><a href="" title="十堰市医疗事故技术鉴定专家库成员申报表">十堰市医疗事故技术鉴定专家库成员申报表</a></li>-->
                  <li v-for="(item,index) in downloadList" :key="item.id"  >
                    <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="symcl_box">
            <div class="symcl_box_title" style="padding-left: 28px;"><img src="../assets/img/down_execl_pic.png" width="20" height="20" />友情链接</div>
            <div class="symcl_box_main">
              <div class="symcl_box_main_cell">
                <div class="goodLinks">
                  <select name="" onchange="javascript:window.open(this.options[this.selectedIndex].value);this.selectedIndex=0">
                    <option selected="">国家省相关机构</option>
                    <option value="http://www.nhc.gov.cn">中华人民共和国国家卫生健康委员会</option>
                    <option value="http://www.cma.org.cn/">中华医学会</option>
                    <option value="http://wjw.hubei.gov.cn/">湖北省卫生健康委员会</option>
                    <option value="http://www.hbma.org.cn/">湖北省医学会</option>
                  </select>
                  <select name="" onchange="javascript:window.open(this.options[this.selectedIndex].value);this.selectedIndex=0">
                    <option>市政府部门</option>
                    <option value="http://wjw.shiyan.gov.cn/">市卫生健康委员会</option>
                  </select>
                  <select name="" onchange="javascript:window.open(this.options[this.selectedIndex].value);this.selectedIndex=0">
                    <option>县市区卫健局</option>
                    <option value="">郧阳区卫健局</option>
                    <option value="http://www.yxws.gov.cn">郧西县卫健局</option>
                    <option value="http://zswjj.zhushan.cn/">竹山县卫健局</option>
                    <option value="http://wsj.zhuxi.gov.cn">竹溪县卫健局</option>
                    <option value="">张湾区卫健局</option>
                    <option value="">丹江口市卫健局</option>
                    <option value="http://www.fxws.gov.cn/">房县卫健局</option>
                    <option value="http://site.conac.cn/www/182711756/40522286/index.html">茅箭区卫健局</option>
                  </select>
                  <select name="" onchange="javascript:window.open(this.options[this.selectedIndex].value);this.selectedIndex=0">
                    <option>医疗卫生单位</option>
                    <option value="http://www.taihehospital.com">十堰市太和医院</option>
                    <option value="http://www.shiyanhospital.com/">十堰市人民医院</option>
                    <option value="http://www.syzyy.cn">十堰市中医院</option>
                    <option value="http://wsjsjd.shiyan.gov.cn/">十堰市卫生计生综合监督执法局</option>
                    <option value="http://cdc.shiyan.gov.cn/">十堰市疾病预防控制中心</option>
                    <option value="http://www.sysxyyy.com/">十堰市西苑医院</option>
                    <option value="http://www.hbsyfy.com">十堰市妇幼保健院</option>
                    <option value="http://www.syxz.net.cn">十堰市中心血站</option>
                    <option value="http://www.shiyanzxy.com/index.html">十堰市中西医结合医院</option>
                    <option value="http://www.systlyy.org.cn/">十堰市铁路医院</option>
                    <option value="http://www.sy120.net">十堰市急救中心</option>
                    <option value="http://www.dfmhp.com.cn">国药东风总医院</option>
                    <option value="http://www.dfmjyy.net">国药东风茅箭医院</option>
                    <option value="http://www.hgyy.com.cn">国药东风花果医院</option>
                  </select>
                  <select name="" onchange="javascript:window.open(this.options[this.selectedIndex].value);this.selectedIndex=0">
                    <option>其他机构</option>
                    <option value="http://www.hbcdc.cn">湖北省疾病预防控制中心</option>
                    <option value="http://wjw.hubei.gov.cn/hbwsjd/">湖北省卫生健康委员会综合监督局</option>
                    <option value="http://www.hbwsrc.cn">湖北卫生人才网</option>
                    <option value="http://www.hbccl.cn">湖北临床检验中心</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--中间三竖模块-->
        <div class="symc_mid">
          <div class="symcm">
            <div class="symcm_title"><router-link :to="{ path: '/continuingMedicalEducation'}">继续教育</router-link></div>
            <div class="symcm_main">
              <div class="symcm_main_box">
                <div class="symcm_main_box_cover"></div>
                <div class="symcm_tab_title">
                  <router-link :to="{ path: '/jxjytzgg'}" :class="{ tab_sel: jxjy==1 }" @mouseenter.native="jxjy=1 ">通知公告</router-link>
                  <router-link :to="{ path: '/jxjyzcfg'}" :class="{ tab_sel: jxjy==2 }" @mouseenter.native="jxjy=2 ">政策法规</router-link>
                  <router-link :to="{ path: '/jxjygzdt'}" :class="{ tab_sel: jxjy==3 }" @mouseenter.native="jxjy=3 ">工作动态</router-link>
                </div>
                <div class="symcm_tab_main">
                  <ul v-show="jxjy==1">
                    <li v-for="(item,index) in jxjytzggList" :key="item.id"  >
                      <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
                    </li>
                  </ul>
                  <ul v-show="jxjy==2">
                    <li v-for="(item,index) in jxjyzcfgList" :key="item.id"  >
                      <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
                    </li>
                  </ul>
                  <ul v-show="jxjy==3">
                    <li v-for="(item,index) in jxjygzdtList" :key="item.id"  >
                      <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="symcm">
            <div class="symcm_title"><router-link :to="{ path: '/learningActivities'}">学会活动</router-link></div>
            <div class="symcm_main">
              <div class="symcm_main_box">
                <div class="symcm_main_box_cover"></div>
                <div class="symcm_tab_title">
                  <router-link :to="{ path: '/xhhdtzgg'}" :class="{ tab_sel: xhhd==1 }" @mouseenter.native="xhhd=1">通知公告</router-link>
                  <router-link :to="{ path: '/xhhdxhgl'}" :class="{ tab_sel: xhhd==2 }" @mouseenter.native="xhhd=2">学会管理</router-link>
                  <router-link :to="{ path: '/xhhdyjxh'}" :class="{ tab_sel: xhhd==3 }" @mouseenter.native="xhhd=3">一级学会</router-link>
                  <router-link :to="{ path: '/xhhdejxh'}" :class="{ tab_sel: xhhd==4 }" @mouseenter.native="xhhd=4">二级学会</router-link>
                </div>
                <div class="symcm_tab_main">
                  <ul>
                    <ul v-show="xhhd==1">
                      <li v-for="(item,index) in xhhdtzggList" :key="item.id"  >
                        <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
                      </li>
                    </ul>
                    <ul v-show="xhhd==2">
                      <li v-for="(item,index) in xhhdxhglList" :key="item.id"  >
                        <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
                      </li>
                    </ul>
                    <ul v-show="xhhd==3">
                      <li v-for="(item,index) in xhhdyjxhList" :key="item.id"  >
                        <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
                      </li>
                    </ul>
                    <ul v-show="xhhd==4">
                      <li v-for="(item,index) in xhhdejxhList" :key="item.id"  >
                        <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
                      </li>
                    </ul>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="symcm">
            <div class="symcm_title"><router-link :to="{ path: '/medicalAccidentIdentification'}">医疗事故鉴定</router-link></div>
            <div class="symcm_main">
              <div class="symcm_main_box">
                <div class="symcm_main_box_cover"></div>
                <div class="symcm_tab_title">
                  <router-link :to="{ path: '/ylsgjdtzgg'}" :class="{ tab_sel: ylsgjd==1 }" @mouseenter.native="ylsgjd=1">通知公告</router-link>
                  <router-link :to="{ path: '/ylsgjdzcfg'}" :class="{ tab_sel: ylsgjd==2 }" @mouseenter.native="ylsgjd=2">政策法规</router-link>
                  <router-link :to="{ path: '/ylsgjdxgwj'}" :class="{ tab_sel: ylsgjd==3 }" @mouseenter.native="ylsgjd=3">相关文件</router-link>
                  <router-link :to="{ path: '/ylsgjdgzdt'}" :class="{ tab_sel: ylsgjd==4 }" @mouseenter.native="ylsgjd=4">工作动态</router-link>
                  <router-link :to="{ path: '/ylsgjdbszn'}" :class="{ tab_sel: ylsgjd==5 }" @mouseenter.native="ylsgjd=5">办事指南</router-link>
                </div>
                <div class="symcm_tab_main">
                  <ul>
                    <ul v-show="ylsgjd==1">
                      <li v-for="(item,index) in ylsgjdtzggList" :key="item.id"  >
                        <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
                      </li>
                    </ul>
                    <ul v-show="ylsgjd==2">
                      <li v-for="(item,index) in ylsgjdzcfgList" :key="item.id"  >
                        <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
                      </li>
                    </ul>
                    <ul v-show="ylsgjd==3">
                      <li v-for="(item,index) in ylsgjdxgwjList" :key="item.id"  >
                        <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
                      </li>
                    </ul>
                    <ul v-show="ylsgjd==4">
                      <li v-for="(item,index) in ylsgjdgzdtList" :key="item.id"  >
                        <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
                      </li>
                    </ul>
                    <ul v-show="ylsgjd==5">
                      <li v-for="(item,index) in ylsgjdbsznList" :key="item.id"  >
                        <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
                      </li>
                    </ul>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="symcm">
            <div class="symcm_title"><router-link :to="{ path: '/regularExamination'}">医师定期考核</router-link></div>
            <div class="symcm_main">
              <div class="symcm_main_box">
                <div class="symcm_main_box_cover"></div>
                <div class="symcm_tab_title">
                  <router-link :to="{ path: '/ysdqkhtzgg'}" :class="{ tab_sel: ysdqkh==1 }" @mouseenter.native="ysdqkh=1">通知公告</router-link>
                  <router-link :to="{ path: '/ysdqkhzcfg'}" :class="{ tab_sel: ysdqkh==2 }" @mouseenter.native="ysdqkh=2">政策法规</router-link>
                  <router-link :to="{ path: '/ysdqkhgzdt'}" :class="{ tab_sel: ysdqkh==3 }" @mouseenter.native="ysdqkh=3">工作动态</router-link>
                </div>
                <div class="symcm_tab_main">
                  <ul>
                    <ul v-show="ysdqkh==1">
                      <li v-for="(item,index) in ysdqkhtzggList" :key="item.id"  >
                        <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
                      </li>
                    </ul>
                    <ul v-show="ysdqkh==2">
                      <li v-for="(item,index) in ysdqkhzcfgList" :key="item.id"  >
                        <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
                      </li>
                    </ul>
                    <ul v-show="ysdqkh==3">
                      <li v-for="(item,index) in ysdqkhgzdtList" :key="item.id"  >
                        <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
                      </li>
                    </ul>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--右侧两竖模块-->
        <latestNewsSimple></latestNewsSimple>
      </div>
      <div class=""></div>
    </div>

    <!--版权-->
    <div style="width:1002px;margin: 0 auto;"><footer1></footer1></div>
  </div>
</template>

<script>
  import {getRecommendList,getWXCallBack,bandUser,getJwtTokenByOpenId,listNews} from '../api/api';
  import  header2 from '../components/Header2'
  import  navigation from '../components/Navigation'
  import  login from '../components/Login'
  import  footer1 from '../components/Footer1'
  import  perfectCourseSimpleList from '../components/PerfectCourseSimpleList'
  import  medicalDynamicNews from '../components/MedicalDynamicNews'
  import  learnCardBind from '../components/LearnCardBind'
  import  md5 from 'crypto-js/md5'
  import {mapGetters} from 'vuex'
  import loginLayer from '../components/LoginLayer';
  import latestNewsSimple from '../components/LatestNewsSimple';

  export default {
    name: 'index',
    components: {
      latestNewsSimple,
      header2,
      login,
      footer1,
      navigation,
      perfectCourseSimpleList,
      medicalDynamicNews,
      learnCardBind,
      loginLayer
    },
    computed: {
      // 使用对象展开运算符将 getters 混入 computed 对象中
      ...mapGetters([
        'userInfo'
        // ...
      ]),
    },
    data () {
      return {
        jxjy:1,
        xhhd:1,
        ylsgjd:1,
        ysdqkh:1,
        rdxwList:[],
        jxjytzggList:[],
        jxjyzcfgList:[],
        jxjygzdtList:[],
        xhhdtzggList:[],
        xhhdxhglList:[],
        xhhdyjxhList:[],
        xhhdejxhList:[],
        ylsgjdtzggList:[],
        ylsgjdzcfgList:[],
        ylsgjdxgwjList:[],
        ylsgjdgzdtList:[],
        ylsgjdbsznList:[],
        ysdqkhtzggList:[],
        ysdqkhzcfgList:[],
        ysdqkhgzdtList:[],
        showLearnCardBind: false,
        loginVisible: false,
        topCarousel: null,
        leftCarousel: null,
        wxBandUserFormVisible:false,
        userForm:{
          userName:'',
          passWord:'',
          openIdWeb:'111'
        },
        userFormRules: {
          userName: [
            {required: true, message: '请输入用户名', trigger: 'blur'}
          ],
          passWord: [
            {required: true, message: '请输入密码', trigger: 'blur'}
          ],
        },
      }
    },

    mounted () {
      document.getElementById("J_GotoTop").style.visibility="hidden";//隐藏在线客服
      /*热点新闻*/
      listNews({
        consultId: 32,
        publishState: 0,
        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        'orderWeight': true,
        orderPublishTime: true,
        pageNum: 1,
        pageSize: 6
      }).then((response) => {
        this.rdxwList = response.data.data.list;
      });
      /*继续教育--通知公告*/
      listNews({
        consultId: 33,
        publishState: 0,
        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        'orderWeight': true,
        orderPublishTime: true,
        pageNum: 1,
        pageSize: 5
      }).then((response) => {
        this.jxjytzggList = response.data.data.list;
      });
      /*继续教育--政策法规*/
      listNews({
        consultId: 34,
        publishState: 0,
        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        'orderWeight': true,
        orderPublishTime: true,
        pageNum: 1,
        pageSize: 5
      }).then((response) => {
        this.jxjyzcfgList = response.data.data.list;
      });
      /*继续教育--工作动态*/
      listNews({
        consultId: 35,
        publishState: 0,
        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        'orderWeight': true,
        orderPublishTime: true,
        pageNum: 1,
        pageSize: 5
      }).then((response) => {
        this.jxjygzdtList = response.data.data.list;
      });

      /*学会活动--通知公告*/
      listNews({
        consultId: 36,
        publishState: 0,
        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        'orderWeight': true,
        orderPublishTime: true,
        pageNum: 1,
        pageSize: 5
      }).then((response) => {
        this.xhhdtzggList = response.data.data.list;
      });
      /*学会活动--学会管理*/
      listNews({
        consultId: 37,
        publishState: 0,
        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        'orderWeight': true,
        orderPublishTime: true,
        pageNum: 1,
        pageSize: 5
      }).then((response) => {
        this.xhhdxhglList = response.data.data.list;
      });
      /*学会活动--一级学会*/
      listNews({
        consultId: 38,
        publishState: 0,
        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        'orderWeight': true,
        orderPublishTime: true,
        pageNum: 1,
        pageSize: 5
      }).then((response) => {
        this.xhhdyjxhList = response.data.data.list;
      });
      /*学会活动--二级学会*/
      listNews({
        consultId: 39,
        publishState: 0,
        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        'orderWeight': true,
        orderPublishTime: true,
        pageNum: 1,
        pageSize: 5
      }).then((response) => {
        this.xhhdejxhList = response.data.data.list;
      });
      /*医疗事故鉴定--通知公告*/
      listNews({
        consultId: 40,
        publishState: 0,
        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        'orderWeight': true,
        orderPublishTime: true,
        pageNum: 1,
        pageSize: 5
      }).then((response) => {
        this.ylsgjdtzggList = response.data.data.list;
      });
      /*医疗事故鉴定--政策法规*/
      listNews({
        consultId: 41,
        publishState: 0,
        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        'orderWeight': true,
        orderPublishTime: true,
        pageNum: 1,
        pageSize: 5
      }).then((response) => {
        this.ylsgjdzcfgList = response.data.data.list;
      });
      /*医疗事故鉴定--相关文件*/
      listNews({
        consultId: 42,
        publishState: 0,
        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        'orderWeight': true,
        orderPublishTime: true,
        pageNum: 1,
        pageSize: 5
      }).then((response) => {
        this.ylsgjdxgwjList = response.data.data.list;
      });
      /*医疗事故鉴定--工作动态*/
      listNews({
        consultId: 43,
        publishState: 0,
        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        'orderWeight': true,
        orderPublishTime: true,
        pageNum: 1,
        pageSize: 5
      }).then((response) => {
        this.ylsgjdgzdtList = response.data.data.list;
      });
      /*医疗事故鉴定--办事指南*/
      listNews({
        consultId: 44,
        publishState: 0,
        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        'orderWeight': true,
        orderPublishTime: true,
        pageNum: 1,
        pageSize: 5
      }).then((response) => {
        this.ylsgjdbsznList = response.data.data.list;
      });
      /*医师定期考核--通知公告*/
      listNews({
        consultId: 45,
        publishState: 0,
        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        'orderWeight': true,
        orderPublishTime: true,
        pageNum: 1,
        pageSize: 5
      }).then((response) => {
        this.ysdqkhtzggList = response.data.data.list;
      });
      /*医师定期考核--政策法规*/
      listNews({
        consultId: 46,
        publishState: 0,
        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        'orderWeight': true,
        orderPublishTime: true,
        pageNum: 1,
        pageSize: 5
      }).then((response) => {
        this.ysdqkhzcfgList = response.data.data.list;
      });
      /*医师定期考核--工作动态*/
      listNews({
        consultId: 47,
        publishState: 0,
        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        'orderWeight': true,
        orderPublishTime: true,
        pageNum: 1,
        pageSize: 5
      }).then((response) => {
        this.ysdqkhgzdtList = response.data.data.list;
      });
      /*首页--下载专区*/
      listNews({
        consultId: 51,
        publishState: 0,
        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        'orderWeight': true,
        orderPublishTime: true,
        pageNum: 1,
        pageSize: 10
      }).then((response) => {
        this.downloadList = response.data.data.list;
      });
      /*轮播图*/
      getRecommendList({
        pageNum: 0,
        pageSize: 5,
        posf: 21,
        posc: null,
        order: 1
      }).then((response) => {
        this.topCarousel = response.data.data.list;
      })
      getRecommendList({
        pageNum: 0,
        pageSize: 5,
        posf: 23,
        posc: null,
        order: 1
      }).then((response) => {
        this.leftCarousel = response.data.data.list;
      })
      //this.chushijiazai();

      /*if(this.$route.query.code && this.$route.query.state){
        //获取access_token
        getWXCallBack({
          code: this.$route.query.code,
          state: this.$route.query.state
        }).then((response) => {
            //扫码用户暂未绑定医博士账号
            if(response.data.exist == false){
              this.wxBandUserFormVisible = true;
              this.userForm.openIdWeb = response.data.openId;
            }else{ //扫码用户已绑定医博士账号
              getJwtTokenByOpenId(response.data.openId).then((response) => {
                if(response.data.code != 1){
                  this.$router.push({ path: '/', query: { token: response.data.token }})
                }else{
                  this.$message.error("获取绑定用户信息失败，请刷新后再试！");
                }
              })
            }
        })
      }*/
    },
    methods: {
      changeTab(name,value){
        console.log(name)
        name=value;
      },
      LearnCardBind(){
        if(this.userInfo!=null){
          this.showLearnCardBind=true;
        }else{
          this.loginVisible=true;
        }
      },
      toSecondPage(type){
        this.$refs.navigation.toSecondPage(type);
      },
      /*chushijiazai(){
        //纯JS写法-医学培训快速连接效果
        //document.getElementById("ncql_all").style.width=(document.getElementById("ncql_all").getElementsByTagName("a").length*142+2)+"px";
        document.getElementById("ncql").onmouseover=(e)=>{
          var x_zuobiao=e.x;
          var x_left=x_zuobiao-document.getElementById("new_content").offsetLeft;
          var x_left_baifenbi=x_left/document.getElementById("ncql").clientWidth;
          var ncql_scroll_left=x_left_baifenbi*document.getElementById("ncql").scrollWidth-500;
          document.getElementById("ncql").scrollLeft=ncql_scroll_left;
        }
      },*/

      onSubmit() {
        this.$refs['userForm'].validate((valid) => {
          if (valid) {
            bandUser({userName: this.userForm.userName, passWord: md5(this.userForm.passWord).toString(),openIdWeb:this.userForm.openIdWeb}).then((response) => {
              if(response.data.code == 1) {
                this.$message.error(response.data.msg);
              }else {
                getJwtTokenByOpenId(this.userForm.openIdWeb).then((response) => {
                  if(response.data.code == 1){
                    this.$message.error("获取绑定用户信息失败，请刷新后再试！");
                  }else{ //扫码用户已绑定医博士账号
                    this.$router.push({ path: '/', query: { token: response.data.token}});
                  }
                })
                this.wxBandUserFormVisible = false;
              }
            })
          } else {
            return false;
          }
        });
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/views/Index.vue